import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FormQuestionHeadingApiModel } from '@app/api/api-models';
import { HttpClientService } from './http-client.service';

@Injectable()
export class CustomQuestionHeadingService {
  public url = 'form-question-headings';

  constructor(private readonly http: HttpClientService) {}

  public add(model): Observable<FormQuestionHeadingApiModel> {
    return this.http.post<FormQuestionHeadingApiModel>(`${this.url}/add`, model);
  }

  public update(model): Observable<FormQuestionHeadingApiModel> {
    return this.http.put<FormQuestionHeadingApiModel>(`${this.url}/update`, model);
  }

  public delete(model): Observable<void> {
    return this.http.delete<void>(`${this.url}/delete/${model.Id}`);
  }
}
